import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Btn, ErrorNote, Field, Input, Panel, Textarea } from "@/components/kmt/ui";
import { errMsg, useLoad, useOwnerApi } from "@/lib/api";
import { SERVICES } from "@/lib/format";
import { PageTitle } from "./DashLayout";

export default function Settings() {
  const api = useOwnerApi();
  const { data } = useLoad(() => api.get("/settings").then((r) => r.data), [api]);
  const [f, setF] = useState<any>(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (data) setF(data);
  }, [data]);
  if (!f) return <p className="text-mist/70">Loading…</p>;
  const c = f.cancellation;
  const setC = (k: string, v: any) => setF({ ...f, cancellation: { ...c, [k]: v } });
  const save = async () => {
    setErr("");
    try {
      setF((await api.put("/settings", f)).data);
      toast.success("Settings saved");
    } catch (e) { setErr(errMsg(e)); }
  };
  return (
    <div className="flex max-w-4xl flex-col gap-6">
      <PageTitle title="Settings" sub="Changes are logged. Existing quotes and signed agreements never change." />
      <Panel title="Master Agreement">
        <div className="grid gap-5">
          <Field label="Version label" hint="Change this when the terms change materially. Customers must sign the new version before their next confirmation.">
            <Input value={f.agreement_version} onChange={(e) => setF({ ...f, agreement_version: e.target.value })} data-testid="settings-agreement-version" />
          </Field>
          <Field label="Agreement text (paragraphs separated by a blank line)">
            <Textarea className="min-h-[360px]" value={f.agreement_text} onChange={(e) => setF({ ...f, agreement_text: e.target.value })} data-testid="settings-agreement-text" />
          </Field>
        </div>
      </Panel>
      <Panel title="Cancellation rules (placeholder — edit to match the agreement)">
        <div className="grid gap-5 sm:grid-cols-2">
          {SERVICES.map((s) => (
            <Field key={s.value} label={`Kept if cancelled 24h+ ahead: ${s.label} (%)`}>
              <Input type="number" min="0" max="100" value={c.outside_24h_pct[s.value]} onChange={(e) => setC("outside_24h_pct", { ...c.outside_24h_pct, [s.value]: e.target.value })} data-testid={`settings-outside-${s.value}`} />
            </Field>
          ))}
          <Field label="Kept within 24h (%)"><Input type="number" value={c.within_24h_pct} onChange={(e) => setC("within_24h_pct", e.target.value)} data-testid="settings-within" /></Field>
          <Field label="Kept within 24h, Custom Long Distance (%)"><Input type="number" value={c.within_24h_pct_cld} onChange={(e) => setC("within_24h_pct_cld", e.target.value)} data-testid="settings-within-cld" /></Field>
          <Field label="Kept for same-day request + same-day pickup (%)" hint="This rule wins when rules overlap. No-shows use the within-24h rate (provisional).">
            <Input type="number" value={c.same_day_request_pct} onChange={(e) => setC("same_day_request_pct", e.target.value)} data-testid="settings-same-day" />
          </Field>
        </div>
      </Panel>
      <ErrorNote msg={err} />
      <Btn onClick={save} className="self-start" data-testid="settings-save-btn">Save settings</Btn>
    </div>
  );
}
